module.exports = __webpack_public_path__ + "static/media/acura.d663392a.png";